<template>
  <div class="faq-wrapper main-view">
    <div class="container position-relative">

    <b-row>
      <b-col data-aos="fade-up-right">
        <h1 class="faq-title mb-5 text-center text-uppercase text-primary">{{ $dt('faq_title', 'faq_title', 'faq')}}</h1>
      </b-col>
    </b-row>
    <b-row class="faq-items" data-aos="fade">
      <b-col style="z-index: 1;">

        <template v-for="index in indexes">
          <div v-if="$hast(`faq_${index}_question`, 'faq')" class="faq-collapse-item" v-bind:key="index">
            <h4 class="text-primary question" v-b-toggle="'answer-' + index">
              <img class="svg" src="../../../assets/img/chev.svg">
              {{ $t(`faq_${index}_question`, 'faq') }}
            </h4>
            <b-collapse class="answer col-12 col-lg-8 p-0 m-0 ml-lg-5" :id="'answer-' + index" v-html="$dt(`faq_${index}_answer`, `faq_${index}_answer`, 'faq')"/>
          </div>
        </template>

      </b-col>
    </b-row>
      <div class="faq-svgs container">
        <img src="../../../assets/img/man.svg" class="svg-man" data-aos="fade-up" data-aos-delay="250">
        <img src="../../../assets/img/woman.svg" class="svg-woman" data-aos="fade-up" data-aos-delay="400">
      </div>
  </div>
  </div>
</template>
<script>
export default {
  name: 'Faq',
  data () {
    return {
      indexes: []
    };
  },
  mounted() {
    this.indexes = [...Array(31).keys()];
  }
}; 
</script>

<style lang="scss">
.faq-svgs {
  position: absolute;
  bottom: -2rem;

  @media (min-width: 768px) {
    bottom: 5rem;
  }

  .svg-man {
    width: 20rem;
    left: -10%;
    position: absolute;
    
    @media (min-width: 576px) {
      left: 15%;
    }

    @media (min-width: 768px) {
      width: 30rem;
    }

    @media (min-width: 992px) {
      left: 35%; 
    }
  }

  .svg-woman {
    width: 20rem;
    left: 35%;
    position: absolute;

    @media (min-width: 576px) {
      left: 50%;
    }

    @media (min-width: 768px) {
      width: 30rem;
    }

    @media (min-width: 992px) {
      left: 55%;      
    }
  }
}

.faq-wrapper {
  padding-top: 10rem;
  background-color: #E6F0EE;

  .faq-title {
    font-weight: 900;
  }
  .faq-items {
    margin-bottom: 10rem;
  }
  .faq-collapse-item {
    margin-bottom: 2rem;

    .question {
      display: flex;
      align-items: center;

      &[aria-expanded="true"] {
        svg, .svg {
          transform: rotate(90deg);
        }
      }

      svg, .svg {
        transition: 250ms;
        margin-right: 2rem;
      }
    }

    .answer {
      color: black;
    }
  }
} 
</style>